import * as tokens from '../../../../../tokens/color.light.generated.js';
export const systemColorLight = {
    color: {
        canvas: {
            100: tokens.SYS_COLOR_CANVAS_100_LIGHT,
            200: tokens.SYS_COLOR_CANVAS_200_LIGHT
        },
        surface: {
            loadingLayer: {
                fill: {
                    100: tokens.SYS_COLOR_SURFACE_LOADING_LAYER_FILL_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_LOADING_LAYER_FILL_200_LIGHT
                }
            },
            interactive: {
                formControls: {
                    default: {
                        100: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_100_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_100_STROKE_LIGHT
                        },
                        200: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_STROKE_LIGHT
                        },
                        300: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_300_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_300_STROKE_LIGHT
                        }
                    },
                    disabled: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_DISABLED_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_DISABLED_STROKE_LIGHT
                    },
                    selected: {
                        100: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_100_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_100_STROKE_LIGHT
                        },
                        200: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_200_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_200_STROKE_LIGHT
                        },
                        300: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_300_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_300_STROKE_LIGHT
                        },
                        disabled: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_DISABLED_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_SELECTED_DISABLED_STROKE_LIGHT
                        }
                    }
                },
                formFields: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_FORMFIELDS_300_STROKE_LIGHT
                    }
                },
                navigation: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_300_STROKE_LIGHT
                    }
                },
                card: {
                    default: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_STROKE_LIGHT
                    },
                    active: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_STROKE_LIGHT
                    }
                },
                primary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_300_STROKE_LIGHT
                    }
                },
                secondary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_300_STROKE_LIGHT
                    }
                },
                tertiary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TERTIARY_300_STROKE_LIGHT
                    }
                },
                quaternary: {
                    100: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_STROKE_LIGHT
                    },
                    200: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_200_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_200_STROKE_LIGHT
                    },
                    300: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_300_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_300_STROKE_LIGHT
                    },
                    400: {
                        fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_400_FILL_LIGHT,
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_400_STROKE_LIGHT
                    }
                },
                tile: {
                    default: {
                        disabled: {
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_DISABLED_FILL_LIGHT,
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_DISABLED_STROKE_LIGHT
                        },
                        100: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_STROKE_LIGHT,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_FILL_STOPS_0_LIGHT,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_100_FILL_STOPS_100_LIGHT
                                }
                            }
                        },
                        200: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_STROKE_LIGHT,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_FILL_STOPS_0_LIGHT,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_DEFAULT_200_FILL_STOPS_100_LIGHT
                                }
                            }
                        }
                    },
                    100: {
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_STROKE_LIGHT,
                        fill: {
                            stops: {
                                0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_FILL_STOPS_0_LIGHT,
                                100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_100_FILL_STOPS_100_LIGHT
                            }
                        }
                    },
                    200: {
                        stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_STROKE_LIGHT,
                        fill: {
                            stops: {
                                0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_FILL_STOPS_0_LIGHT,
                                100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_200_FILL_STOPS_100_LIGHT
                            }
                        }
                    },
                    selected: {
                        disabled: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_DISABLED_STROKE_LIGHT,
                            fill: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_DISABLED_FILL_LIGHT
                        },
                        100: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_STROKE_LIGHT,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_FILL_STOPS_0_LIGHT,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_100_FILL_STOPS_100_LIGHT
                                }
                            }
                        },
                        200: {
                            stroke: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_STROKE_LIGHT,
                            fill: {
                                stops: {
                                    0: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_FILL_STOPS_0_LIGHT,
                                    100: tokens.SYS_COLOR_SURFACE_INTERACTIVE_TILE_SELECTED_200_FILL_STOPS_100_LIGHT
                                }
                            }
                        }
                    }
                }
            },
            neutral: {
                100: tokens.SYS_COLOR_SURFACE_NEUTRAL_100_LIGHT,
                200: tokens.SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT,
                300: tokens.SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
                400: tokens.SYS_COLOR_SURFACE_NEUTRAL_400_LIGHT,
                500: tokens.SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
                600: tokens.SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
                700: tokens.SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT,
                800: tokens.SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
                transparent: tokens.SYS_COLOR_SURFACE_NEUTRAL_TRANSPARENT_LIGHT
            },
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_SURFACE_SIGNAL_POSITIVE_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_SIGNAL_POSITIVE_200_LIGHT
                },
                negative: tokens.SYS_COLOR_SURFACE_SIGNAL_NEGATIVE_LIGHT,
                pending: tokens.SYS_COLOR_SURFACE_SIGNAL_PENDING_LIGHT,
                focus: tokens.SYS_COLOR_SURFACE_SIGNAL_FOCUS_LIGHT
            },
            disabled: {
                stroke: {
                    100: tokens.SYS_COLOR_SURFACE_DISABLED_STROKE_100_LIGHT,
                    transparent: tokens.SYS_COLOR_SURFACE_DISABLED_STROKE_TRANSPARENT_LIGHT
                },
                fill: {
                    100: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_100_LIGHT,
                    200: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_200_LIGHT,
                    transparent: tokens.SYS_COLOR_SURFACE_DISABLED_FILL_TRANSPARENT_LIGHT
                }
            },
            scrim: {
                default: tokens.SYS_COLOR_SURFACE_SCRIM_DEFAULT_LIGHT
            },
            highlight: {
                primary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT,
                secondary: tokens.SYS_COLOR_SURFACE_HIGHLIGHT_SECONDARY_LIGHT
            },
            encourage: {
                fill: tokens.SYS_COLOR_SURFACE_ENCOURAGE_FILL_LIGHT,
                stroke: tokens.SYS_COLOR_SURFACE_ENCOURAGE_STROKE_LIGHT
            }
        },
        elevation: {
            level1: {
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL1_FILL_STOPS_0_LIGHT,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL1_FILL_STOPS_100_LIGHT
                    }
                },
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL1_STROKE_LIGHT
            },
            level2: {
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL2_STROKE_LIGHT,
                shadowColor: tokens.SYS_COLOR_ELEVATION_LEVEL2_SHADOW_COLOR_LIGHT,
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_0_LIGHT,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_100_LIGHT
                    }
                }
            },
            level3: {
                fill: {
                    stops: {
                        0: tokens.SYS_COLOR_ELEVATION_LEVEL3_FILL_STOPS_0_LIGHT,
                        100: tokens.SYS_COLOR_ELEVATION_LEVEL3_FILL_STOPS_100_LIGHT
                    }
                },
                stroke: tokens.SYS_COLOR_ELEVATION_LEVEL3_STROKE_LIGHT,
                shadowColor: tokens.SYS_COLOR_ELEVATION_LEVEL3_SHADOW_COLOR_LIGHT
            }
        },
        text: {
            copy: {
                default: tokens.SYS_COLOR_TEXT_COPY_DEFAULT_LIGHT
            },
            headline: {
                default: tokens.SYS_COLOR_TEXT_HEADLINE_DEFAULT_LIGHT
            },
            display: {
                default: tokens.SYS_COLOR_TEXT_DISPLAY_DEFAULT_LIGHT
            },
            caption: {
                default: tokens.SYS_COLOR_TEXT_CAPTION_DEFAULT_LIGHT
            }
        },
        static: {
            100: {
                opa20: tokens.SYS_COLOR_STATIC_100_OPA20_LIGHT,
                solid: tokens.SYS_COLOR_STATIC_100_SOLID_LIGHT
            },
            900: {
                opa20: tokens.SYS_COLOR_STATIC_900_OPA20_LIGHT,
                solid: tokens.SYS_COLOR_STATIC_900_SOLID_LIGHT
            }
        },
        foreground: {
            signal: {
                positive: {
                    100: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITIVE_100_LIGHT,
                    200: tokens.SYS_COLOR_FOREGROUND_SIGNAL_POSITIVE_200_LIGHT
                },
                negative: tokens.SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_LIGHT,
                pending: tokens.SYS_COLOR_FOREGROUND_SIGNAL_PENDING_LIGHT
            },
            neutral: {
                100: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_100_LIGHT,
                200: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT,
                300: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
                400: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_400_LIGHT,
                500: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_500_LIGHT,
                600: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_600_LIGHT,
                700: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_700_LIGHT,
                800: tokens.SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT
            },
            onEncourage: {
                default: tokens.SYS_COLOR_FOREGROUND_ON_ENCOURAGE_DEFAULT_LIGHT
            }
        }
    },
    gradient: {
        elevation: {
            level1: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL1_FILL_LIGHT },
            level2: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL2_FILL_LIGHT },
            level3: { fill: tokens.SYS_GRADIENT_ELEVATION_LEVEL3_FILL_LIGHT }
        }
    }
};
//# sourceMappingURL=color.light.js.map